import {
  desktopPluginActionDefinitionSchema,
  desktopPluginDescriptorSchema,
  desktopPluginExecutionRequestSchema,
  desktopPluginExecutionResultSchema,
  desktopPluginFieldDefinitionSchema,
  desktopPluginFieldTypeSchema,
} from "@bitsentry-ce/core/features/plugins";
import { z } from "zod";

/**
 * Cloud transport uses the exact serializable schemas from the desktop Plugin
 * SDK. Code handlers and Effect runtimes stay inside the downloaded artifact;
 * descriptors and action requests can safely cross HTTP/tRPC boundaries.
 */
export const pluginFieldTypeSchema = desktopPluginFieldTypeSchema;
export const pluginFieldSchema = desktopPluginFieldDefinitionSchema;
export const pluginActionSchema = desktopPluginActionDefinitionSchema;
export const cloudPluginDescriptorSchema = desktopPluginDescriptorSchema;
export const cloudPluginListResponseSchema = z.array(
  cloudPluginDescriptorSchema,
);

export const cloudPluginWorkerListResponseSchema = z.union([
  cloudPluginListResponseSchema,
  z.object({ plugins: cloudPluginListResponseSchema }),
]);

export const cloudPluginDescribeRequestSchema = z.object({
  pluginId: z.string().trim().min(1),
});

export const cloudPluginExecutionRequestSchema =
  desktopPluginExecutionRequestSchema;
export const cloudPluginExecutionResultSchema =
  desktopPluginExecutionResultSchema;

export type CloudPluginDescriptor = z.output<
  typeof cloudPluginDescriptorSchema
>;
export type CloudPluginListResponse = z.output<
  typeof cloudPluginListResponseSchema
>;
export type CloudPluginWorkerListResponse = z.output<
  typeof cloudPluginWorkerListResponseSchema
>;
export type CloudPluginExecutionRequest = z.output<
  typeof cloudPluginExecutionRequestSchema
>;
export type CloudPluginExecutionResult = z.output<
  typeof cloudPluginExecutionResultSchema
>;
